import { render } from "./CajaDetalle.vue?vue&type=template&id=20759d25&scoped=true"
import script from "./CajaDetalle.vue?vue&type=script&lang=js"
export * from "./CajaDetalle.vue?vue&type=script&lang=js"

import "./CajaDetalle.vue?vue&type=style&index=0&id=20759d25&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20759d25"]])

export default __exports__